import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {UIUtil} from 'yougile-util'
import {UserAvatar} from '@components/user-avatar'
import {UserName} from '@components/user-name'
import {noPropagate} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {useScriptsCodeStore} from '../scripts-code-store'
import {useScriptsObjNavStore} from '../scripts-obj-nav-store'
import {useScriptsStore} from '../scripts-store'

// eslint-disable-next-line max-lines-per-function
export const ToolsObj = observer(() => {
  const [state, store] = useScriptsStore()
  const [objNavState, objNavStore] = useScriptsObjNavStore()
  const [, codeStore] = useScriptsCodeStore()
  const {companyId} = store.globalState

  return (
    <div className="scr-obj-nav">
      <div className="scr-obj-head">
        {!!objNavStore.currentTitle() && (
          <div>
            <span onClick={objNavStore.goUp} className="scr-obj-up" />
            <span>{objNavStore.currentTitle()}</span>
          </div>
        )}
        {!objNavStore.currentTitle() && (
          <div className="scr-obj-nav-head-hint">{Lang.msg.objNavHint}</div>
        )}
      </div>
      {!!objNavState.entityId &&
        objNavStore.list().map(item => (
          <div
            key={item.id}
            onClick={() => objNavStore.goTo(item.id)}
            className={cn(
              'scr-obj-item',
              objNavState.shownItemId === item.id && 'shown'
            )}
          >
            <div
              className="scr-obj-line"
              draggable
              onDragStart={e =>
                objNavStore.dragStart(objNavStore.getCode(item.id), e)
              }
            >
              <span
                className={`scr-obj-icon scr-obj-icon-${objNavStore.getType(
                  item.id
                )}`}
              />
              {codeStore.getName(item)}
            </div>

            <i
              className="fa fa-info scr-obj-info"
              onClick={evt => objNavStore.toggleShowInfo(item.id, evt)}
            />
            <div className="scr-obj-info-cnt" onClick={noPropagate}>
              <div
                className="scr-obj-info-btn _button"
                onClick={() => objNavStore.insertIntoCode(item.id)}
              >
                {Lang.msg.insertToCode}
              </div>
              <div className="scr-obj-info-row first">
                <div className="scr-obj-info-col-name">Id</div>
                <div className="scr-obj-info-col">{item.id}</div>
              </div>
              <div className="scr-obj-info-row">
                <div className="scr-obj-info-col-name">Type</div>
                <div className="scr-obj-info-col">
                  {objNavStore.getType(item.id)}
                </div>
              </div>
              <div className="scr-obj-info-row">
                <div className="scr-obj-info-col-name">Timestamp</div>
                <div className="scr-obj-info-col">{item.timestamp}</div>
              </div>
              <div className="scr-obj-info-row">
                <div className="scr-obj-info-col-name">Deleted</div>
                <div className="scr-obj-info-col">
                  {item.deleted ? 'true' : 'false'}
                </div>
              </div>
            </div>
          </div>
        ))}

      {!objNavState.entityId && !objNavState.showUsers && (
        <div>
          <div
            onClick={() => objNavStore.goTo(companyId)}
            className={cn(
              'scr-obj-item',
              objNavState.shownItemId === companyId && 'shown'
            )}
          >
            <div
              className="scr-obj-line"
              draggable
              onDragStart={e =>
                objNavStore.dragStart(objNavStore.getCode(companyId), e)
              }
            >
              <span className="scr-obj-icon scr-obj-icon-company" />
              {Lang.msg.company} “{state.companyName}”
            </div>
            <i
              className="fa fa-info scr-obj-info"
              onClick={evt => objNavStore.toggleShowInfo(companyId, evt)}
            />
            <div className="scr-obj-info-cnt" onClick={noPropagate}>
              <div
                className="scr-obj-info-btn _button"
                onClick={() => objNavStore.insertIntoCode(companyId)}
              >
                {Lang.msg.insertToCode}
              </div>
              <div className="scr-obj-info-row first">
                <div className="scr-obj-info-col-name">Id</div>
                <div className="scr-obj-info-col">{companyId}</div>
              </div>
              <div className="scr-obj-info-row">
                <div className="scr-obj-info-col-name">Type</div>
                <div className="scr-obj-info-col">Company</div>
              </div>
            </div>
          </div>
          <div
            onClick={() => objNavStore.setShowUsers(true)}
            className="scr-obj-item"
          >
            <div
              className="scr-obj-line"
              draggable
              onDragStart={e => objNavStore.dragStart('Users.listAll();', e)}
            >
              <span className="scr-obj-icon scr-obj-icon-user" />
              Users
            </div>
          </div>
        </div>
      )}

      {!!objNavState.showUsers && (
        <div>
          {objNavStore.listUsers().map(user => (
            <div
              key={user.id}
              draggable
              onDragStart={e =>
                objNavStore.dragStart(objNavStore.getCode(user.id), e)
              }
              className={cn(
                'scr-obj-item',
                objNavState.shownItemId === user.id && 'shown'
              )}
            >
              <UserAvatar user={user} />
              <UserName user={user} />
              <i
                className="fa fa-info scr-obj-info"
                onClick={evt => objNavStore.toggleShowInfo(user.id, evt)}
              />
              <div
                className="scr-obj-info-cnt"
                onMouseDown={UIUtil.setConsumed}
              >
                <div
                  className="scr-obj-info-btn _button"
                  onClick={() => objNavStore.insertIntoCode(user.id)}
                >
                  {Lang.msg.insertToCode}
                </div>
                <div className="scr-obj-info-row first">
                  <div className="scr-obj-info-col-name">Id</div>
                  <div className="scr-obj-info-col">{user.id}</div>
                </div>
                <div className="scr-obj-info-row">
                  <div className="scr-obj-info-col-name">Type</div>
                  <div className="scr-obj-info-col">user</div>
                </div>
                <div className="scr-obj-info-row">
                  <div className="scr-obj-info-col-name">Email</div>
                  <div className="scr-obj-info-col">{user.email}</div>
                </div>
                <div className="scr-obj-info-row">
                  <div className="scr-obj-info-col-name">Timestamp</div>
                  <div className="scr-obj-info-col">{user.timestamp}</div>
                </div>
                <div className="scr-obj-info-row">
                  <div className="scr-obj-info-col-name">Deleted</div>
                  <div className="scr-obj-info-col">
                    {user.deleted ? 'true' : 'false'}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
})
